import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

export default class StartTimesRoute extends Route
{
	@service store;

	async model(params)
	{
		const events = await this.store.findAll('Event');
		const translations = await this.store.findAll('Translation');

		return {
			events: events,
			translations: translations
		};
	}
}